<template>
    <div class="container">
        <div class="row my-5">
            <div class="col-12">
                <dl v-if="msg !== ''" class="row mb-5">
                    <dd class="offset-sm-3 col-sm-9 col-12">
                        <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                            <i :class="`far fa-${emoji}`"></i> {{ msg }}
                        </div>
                    </dd>
                </dl>
                <div v-if="showAddCard" class="card bg-light">
                    <div class="card-body">
                        <form>
                            <dl class="row">
                                <dt class="col-lg-8 col-md-7 col-sm-6 col-12">
                                    <h4 class="mb-3 text-dark-green nav-settings-head">New Payment Card</h4>
                                </dt>
                                <dd class="col-lg-4 col-md-5 col-sm-6 col-12">
                                    <div class="row">
                                        <div class="col-5">
                                            <span @click.prevent="hideAddCardFxn" class="btn btn-light btn-sm bg-white form-control">Cancel</span>
                                        </div>
                                        <div class="col-7">
                                            <button @click.prevent="saveCard" class="loadn btn btn-dark-green btn-sm form-control">Save Card</button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-3">Card Holders Name</dt>
                                <dd class="col-sm-9"><p><input v-model="name" type="text" class="form-control no-lines bg-white" placeholder="Full Name"></p></dd>

                                <dt class="col-sm-3">Card Number</dt>
                                <dd class="col-sm-9"><p><input v-model="number" type="number" placeholder="0000 0000 0000 0000" class="form-control no-lines bg-white"></p></dd>

                                <dt class="col-sm-3">Expires</dt>
                                <dd class="col-sm-3">
                                    <select v-model="month" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                        <option disabled value="">month</option>
                                        <option v-for="(x, i) in numMonths" :key="i" :value="x">{{x}}</option>
                                    </select>
                                </dd>
                                <dd class="col-sm-3">
                                    <select v-model="year" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                        <option disabled value="">year</option>
                                        <option v-for="(x, i) in numYear" :key="i" :value="x">{{x}}</option>
                                    </select>
                                </dd>
                                <dd class="col-sm-3">
                                    <p><input v-model="cvv" type="number" placeholder="CVV" class="form-control no-lines bg-white"></p>
                                </dd>
                            </dl>
                        </form>
                    </div>
                </div>
                <div v-if="showSavedCards" class="card bg-white">
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-lg-10 col-md-8 col-sm-6 col-12">
                                <h3 class="mb-3 text-dark-green nav-settings-head">Saved Cards</h3>
                            </dt>
                            <dd class="col-lg-2 col-md-4 col-sm-6 col-12">
                                <button @click.prevent="showAddCardFxn" class="btn btn-warning btn-sm form-control">New Card</button>
                            </dd>
                        </dl>
                        <div v-if="savedCards" class="table-responsive">
                            <table class="table table-striped">
                                <tbody>
                                    <tr v-for="(card, i) in savedCards" :key="i">
                                        <td>{{i + 1}}.</td>
                                        <td class="text-capitalize">{{card.name}}</td>
                                        <td>
                                            <i v-if="card.type == 'payment'" :class="`fas fa-credit-card mr-2`"></i>
                                            <i v-else :class="`fab fa-cc-${card.type} mr-2`"></i>
                                            <span class="text-uppercase">{{card.number | mask}}</span>
                                        </td>
                                        <td>{{card.month}}/{{card.year}}</td>
                                        <td>
                                            <template v-if="savedCards.length > 1">
                                                <i @click="deleteCard(card._id)" class="fas fa-trash-alt text-danger clickable mx-2 fa-lg"></i>
                                            </template>
                                            <i v-if="card.default" class="fas fa-toggle-on text-dark-green mx-2 clickable fa-lg"></i>
                                            <i v-else @click="markDefault(card._id)" class="fas fa-toggle-off mx-2 fa-lg clickable"></i> 
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="text-center">
                            <i class="fas fa-credit-card fa-3x text-muted my-3"></i>
                            <p>You don't seem to have any card saved yet!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Card",
    data() {
        return {
            showAddCard: false,
            showSavedCards: true,
            monthsArr: [],
            yearArr: [],
            name: '',
            number: '',
            month: '',
            year: '',
            cvv: '',
            msg: '',
            color: 'danger',
            emoji: 'frown'
        }
    },
    methods: {
        ...mapActions(['addNewCard', 'myCards', 'markCardDefault', 'deletePaymentCard']),
        resetAlert() {
            this.msg = '',
            this.color = 'danger',
            this.emoji = 'frown'
        },
        hideAddCardFxn() {
            this.resetAlert()
            this.showAddCard = false
            this.showSavedCards = true
        },
        showAddCardFxn() {
            this.resetAlert()
            this.showSavedCards = false
            this.showAddCard = true
        },
        saveCard() {
            this.resetAlert()
            if(this.name === ''){ this.msg = "Card holder name is required"; return }
            if(this.number === ''){ this.msg = "Card number is required"; return }
            if(this.number.length < 13){ this.msg = "Incomplete card number entered"; return }
            if(this.month === ''){ this.msg = "Card expiration month is required"; return }
            if(this.year === ''){ this.msg = "Card expiration year is required"; return }
            if(this.cvv === ''){ this.msg = "Card CVV is required"; return }
            if(this.cvv.length < 3){ this.msg = "Incomplete CVV entered"; return }

            let cardObj = {
                userId: this.user._id,
                type: this.detectCardType(this.number),
                name: this.name.toLowerCase(),
                number: this.number,
                month: this.month,
                year: this.year,
                cvv: this.cvv
            }
            this.addNewCard(cardObj)
            .then(() => {
                this.color = "success"
                this.emoji = "smile"
                this.msg = "Card successfully saved!"
                this.number = ""
                this.cvv = ""
                this.showAddCard = false
                this.hideAddCardFxn()
            }).catch((e) => {
                this.msg = "Saving card failed, double check and try again."
            })
        },
        fetchMyCards() {
            let userObj = {
                userId: this.user._id
            }
            this.myCards(userObj).then(() => {}).catch((e) => {})
        },
        markDefault(theCardId) {
            this.resetAlert()
            let cardObj = {
                userId: this.user._id,
                cardId: theCardId
            }
            this.markCardDefault(cardObj)
            .then(() => {
                this.color = "success"
                this.emoji = "smile"
                this.msg = "Card successfully marked as default!"
            }).catch((e) => {
                this.msg = "Marking card as default failed, try again."
            })
        },
        deleteCard(theCardId) {
            this.resetAlert()
            let cardObj = {
                userId: this.user._id,
                cardId: theCardId
            }
            this.deletePaymentCard(cardObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.emoji = "smile"
                }
                this.msg = data.msg
                // this.msg = "Card deleted successfully!"
            }).catch((e) => {
                this.msg = "Deleting card as failed, try again."
            })
        },
        detectCardType(val) {
            val = val.slice(0, 2)
            val = parseInt(val)
            let type = ''
            if (val >= 40 && val <= 49) {
                type = 'visa';
            } else if (val >= 51 && val <= 55) {
                type = 'mastercard';
            } else if (val >= 60 && val <= 65) {
                type = 'discover';
            } else if (val >= 34 && val <= 37) {
                type = 'amex';
            } else {
                type = 'payment'
            }
            return type
        },
    },
    computed: {
        ...mapGetters(['user', 'cards']),
        savedCards() {
            if(this.cards && this.cards.length){
                return this.cards
            }
            return false
        },
        numMonths() {
            for(var x = 1; x <= 12; x++){
                if(x < 10){
                    this.monthsArr.push('0' + x)
                }else{
                    this.monthsArr.push(x)
                }
            }
            return this.monthsArr
        },
        numYear() {
            for(var x = 0; x <= 10; x++){
                this.yearArr.push(x + 20)
            }
            return this.yearArr
        },
    },
    mounted() {
        this.fetchMyCards()
    }
}
</script>